import {
	Outlet,
	useLocation,
	useNavigate,
	useSearchParams,
} from 'react-router-dom';
import Header from '@/components/ui/Header';
import { CircleUserRound, LayoutDashboard } from 'lucide-react';
import { Sidebar } from '@/components/ui';
import { useEffect, useState } from 'react';
import { useLogoutUser } from '@/services';
import { SidebarProvider } from '@/context/SidebarContext';
const PublicSchedulingLayout = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const [searchParams] = useSearchParams();
	const [showSidebar, setShowSidebar] = useState(false);

	const isAgendamentoRoute = location.pathname.startsWith('/agendamento');

	/** Em `/agendamento` a sidebar nunca aparece (guest ou logado, com ou sem `s_s`). */
	const hideSidebarMenu = isAgendamentoRoute;
	const shouldShowSidebar = showSidebar && !isAgendamentoRoute;

	const sidebarItems = [
		{
			icon: <LayoutDashboard className="h-5 w-5" />,
			text: 'Início',
			path: '/home',
		},
		{
			icon: <CircleUserRound className="h-5 w-5" />,
			text: 'Perfil',
			path: '/perfil',
		},
	];

	const showSidebarParams = searchParams.get('s_s');

	useEffect(() => {
		if (showSidebarParams) setShowSidebar(showSidebarParams === 'true');
	}, [searchParams]);

	// Hook de logout do usuário
	const { mutate: logout } = useLogoutUser(() => navigate('/login'));

	return (
		<SidebarProvider items={sidebarItems} onLogout={logout}>
			<section className="flex min-h-screen w-full flex-col overflow-x-hidden bg-zinc-50">
				{/* O Header agora pega o toggleSidebar sozinho do contexto */}
				<Header hideSidebarMenu={hideSidebarMenu} />

				<main className="flex h-[calc(100vh-64px)] w-full">
					{shouldShowSidebar && (
						/* A Sidebar agora pega items, isExpanded e logout sozinho do contexto */
						<Sidebar />
					)}
					<section className="z-0 m-auto h-[calc(100vh-64px)] w-full flex-1 overflow-y-scroll md:px-4">
						<Outlet />
					</section>
				</main>
			</section>
		</SidebarProvider>
	);
};

export { PublicSchedulingLayout };
